import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import * as _ from "lodash";
import { allSocialLinks, header } from "../constants/profile";

function Contact() {
  const [socialLinks, setSocialLinks] = useState(allSocialLinks);

  const setHover = (social, value) => {
    setSocialLinks((prev) => {
      const index = prev.findIndex((val) => val.title === social.title);
      const newObj = _.cloneDeep(prev);
      newObj[index].hover = value;
      return newObj;
    });
  };

  return (
    <div className="w-100vw h-80vh">
      <Container>
        <div
          className="position-relative my-5 py-5 text-center"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <h1 className="bolder fg-heading text-white mb-0">
            GET IN <span className="bolder primary-color">TOUCH</span>
          </h1>
          <h1 className="bolder bg-title">CONTACT</h1>
        </div>

        <Row>
          <Col
            lg="4"
            className="px-3 px-lg-0"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <h2 className="bolder text-white mb-4">Tell me about your Idea!</h2>
            <div className="text-white">
              Feel free to get in touch with me. I am always open to discussing
              new projects, creative ideas or opportunities to be part of your
              visions.
            </div>
            <div className="mt-4">
              <a
                className="link-styles text-white fw-bold"
                href={`mailto:${header.links.email}`}
              >
                <div className="d-flex align-items-center">
                  <img
                    src="/assets/about/email.svg"
                    alt="email"
                    className="medium-icon d-inline-block me-3"
                  />
                  <div className="d-inline-block">
                    <h6 className="mb-0 text-white-50">MAIL ME</h6>
                    <h6 className="mb-0 text-white bolder">
                      {header.links.email}
                    </h6>
                  </div>
                </div>
              </a>

              <a
                className="link-styles text-white fw-bold"
                href={`tel:${header.links.tel}`}
              >
                <div className="mt-4 d-flex align-items-center">
                  <img
                    src="/assets/about/phone.svg"
                    alt="email"
                    className="medium-icon d-inline-block me-3"
                  />
                  <div className="d-inline-block">
                    <h6 className="mb-0 text-white-50">CALL ME</h6>
                    <h6 className="mb-0 text-white bolder">
                      {header.links.tel}
                    </h6>
                  </div>
                </div>
              </a>

              <div className="my-5">
                {socialLinks.map((link) => (
                  <img
                    role="button"
                    onMouseEnter={() => setHover(link, true)}
                    onMouseLeave={() => setHover(link, false)}
                    key={link.title}
                    src={
                      link.hover
                        ? `${link.image}-active.svg`
                        : `${link.image}.svg`
                    }
                    alt={link.title}
                    className="social-img me-3"
                    onClick={() => window.open(link.url, "_blank")}
                  />
                ))}
              </div>
            </div>
          </Col>
          <Col lg="8" data-aos="fade-left" data-aos-duration="1000">
            <form method="post" name="contact">
              <input hidden name="thanks" type="text" />
              <input name="form-name" type="hidden" value="contact" />
              <Row>
                <Col className="ps-lg-5 pe-lg-3 px-0" lg="6">
                  <input
                    placeholder="Email Address"
                    className="form-input my-2"
                    type="email"
                    name="email"
                    required
                  />
                </Col>
                <Col className="pe-lg-5 ps-lg-3 px-0" lg="6">
                  <input
                    placeholder="Name"
                    className="form-input my-2"
                    name="name"
                    type="text"
                  />
                </Col>
                <Col className="mt-3 px-lg-5 px-0" md="12">
                  <textarea
                    placeholder="Message"
                    className="form-input my-2 text-area-input"
                    rows="4"
                    name="message"
                    required
                  />
                </Col>
              </Row>

              <div className="mt-3 px-lg-5 px-0 w-100 d-flex justify-content-lg-start justify-content-center">
                <button type="submit" className="button mb-5 mb-lg-0">
                  <span className="button-text">Send Message</span>
                  <img
                    src="/assets/send.svg"
                    alt="send"
                    className="button-icon p-2"
                  />
                </button>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Contact;
